import React, { useRef } from 'react';
import { isNil, trim } from 'lodash';
import common from '../../../common/common';
import translateService from '../../../common/translateService';
import RangeInput from '../common/RangeInput.jsx';
import Button from '../../Button.jsx';
import productsAvailabilityStatus from './productsAvailabilityStatus';

import './ProductOptions.scss';

const ProductQuantity = (props) => {
  const handleButtonClick = () => {
    props.handleCTAClick();
  };

  const isUnpurchaseable = () => {
    return (
      props.availabilityStatus === productsAvailabilityStatus.discontinued ||
      props.availabilityStatus === productsAvailabilityStatus.qtyDiscontinued ||
      props.availabilityStatus === '' ||
      props.availabilityStatus === productsAvailabilityStatus.optionUnavailable
    );
  };

  const getCssClass = () => {
    if (isUnpurchaseable()) {
      return '';
    }

    return props.availabilityStatus === productsAvailabilityStatus.booking ||
      props.qtySelected <= props.qtyAvailable ||
      props.availabilityStatus === productsAvailabilityStatus.soonAvailable
      ? 'active'
      : 'reassortment';
  };

  const getText = () => {
    if (isUnpurchaseable()) return 'addToCart';
    if (props.selectiveDistribution) return 'buyOn';

    return props.availabilityStatus === productsAvailabilityStatus.booking ||
      props.qtySelected <= props.qtyAvailable ||
      props.availabilityStatus === productsAvailabilityStatus.soonAvailable
      ? 'addToCart'
      : 'activateReassortMentNotification';
  };

  return (
    <div className='prd-option prd-qty'>
      <h2>
        <span className='prd-options-name'>
          {translateService.get(`productDetail.quantity`)}
        </span>
      </h2>
      <div className='prd-qty-container'>
        <RangeInput
          qtySelected={props.qtySelected}
          decreaseQty={props.handleDecreaseQty}
          updateQty={props.handleUpdateQty}
          handleBlur={props.checkInput}
          increaseQty={props.handleIncreaseQty}
          minQty={1}
          maxQty={999}
        />
        <div className='prd-qty-cta'>
          {!props.userAuthenticated &&
          !isUnpurchaseable() &&
          props.availabilityStatus !== productsAvailabilityStatus.booking &&
          props.availabilityStatus !==
            productsAvailabilityStatus.soonAvailable &&
          props.qtySelected > props.qtyAvailable ? (
            <p
              dangerouslySetInnerHTML={{
                __html: translateService.interpolate(
                  `productDetail.logInToAddReassNotification`,
                  {
                    url: common.getSiteUrl(
                      `${
                        window.$pathBase
                      }Account/LogOn?returnUrl=${encodeURIComponent(
                        window.$pathBase + props.slug + window.location.search,
                      )}`,
                    ),
                  },
                ),
              }}
            />
          ) : (
            <Button
              ref={props.buttonRef}
              onClick={handleButtonClick}
              className={trim(`prd-qty-add-to-cart ${getCssClass()}`.trim())}
              text={translateService.get(`productDetail.${getText()}`)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductQuantity;
